// extracted by mini-css-extract-plugin
export default {"errorWrapper":"ErrorNotification_errorWrapper__cOEX5","error":"ErrorNotification_error__C0Q2Z"};